import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/ashwin-new.jpg";
import Tilt from "react-parallax-tilt";
import { AiFillGithub, AiOutlineTwitter } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import axios from "axios";

function Home2() {
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    getCount();
  }, []);

  const getCount = async () => {
    try {
      const { data } = await axios.get(
        "https://api.countapi.xyz/hit/willowy-paprenjak-351fe4.netlify.app/visited"
      );
      setCounter(data.value);
    } catch (error) {
      setCounter(102);
    }
  };

  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2em" }}>
              ALLOW ME <span className="purple"> TO INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              I have developed a passion for programming and have gained a
              significant amount of knowledge and skills in the field.
              <br />
              <br />I am proficient in classic programming languages such as
              <b className="purple"> Javascript and C++ . </b>
              <br />
              <br />I am interested in building innovative{" "}
              <b className="purple"> Web Technologies and Products </b> as well
              as exploring the realm of <b className="purple">Deep Learning.</b>
              <br />
              <br />I frequently utilize my passion for development by creating
              products using <b className="purple"> Node.js</b> and
              <b className="purple">
                {" "}
                Modern Javascript Library and Frameworks
              </b>
              &nbsp; like
              <b className="purple"> React.js .</b>
            </p>
          </Col>
          <Col md={3} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>CONNECT WITH ME</h1>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/ashwin2003"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/ashwinJagarwal"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/ashwin-jagarwal-786799187/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
            <h3>This site hase been visited {counter} times.</h3>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
